import { render, staticRenderFns } from "./AutoReminderInformation.vue?vue&type=template&id=31537bae&lang=html&"
import script from "./AutoReminderInformation.vue?vue&type=script&lang=js&"
export * from "./AutoReminderInformation.vue?vue&type=script&lang=js&"
import style0 from "./AutoReminderInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports